import React from 'react'

import { getIntercomAppId } from './helpers'

export function useIntercomProps<Element = HTMLButtonElement | HTMLAnchorElement>(
  className?: string,
  onClick?: React.MouseEventHandler<Element>
) {
  return React.useMemo(() => {
    if (!getIntercomAppId() && process.env.NODE_ENV === 'development') {
      return {
        className,
        onClick: (event: React.MouseEvent<Element>) => {
          alert('[Development Mode] Launch Intercom')
          onClick?.(event)
        },
      }
    } else {
      return {
        className,
        onClick,
      }
    }
  }, [className, onClick])
}
